<template>
    <div class="dialog draggable-item bg-light light w-100-sm w-100-md w-75-lg  w-50-xl" v-cloak>

        <DialogTitle :title="serviceAccount.id == null ? $t('Add Service Account') : serviceAccount.name"
            :defaultTitle="serviceAccount.id == null ? $t('Add Service Account') : $t('Edit/Test Service Account')"
            :subTitle="serviceAccount.type_name" @closeDialog="$root.$emit('CLOSESERVICEACCOUNTDIALOG')" />


        <div class="dialog-content overflow bg-light">

            <div class="form-group">
                <label>{{ $t("Name") }}*</label>
                <input data-role="input" type="text" v-model.trim="serviceAccount.name" maxlength="50"
                    :placeholder="$t('enter name')" data-prepend="<span class='mif-pencil'></span>" />
                
            </div>

            <div class="form-group">
                <label>{{ $t("Sender") }}*</label>
                <input data-role="input" type="text" v-model.trim="serviceAccount.options.senderAddress"
                    :placeholder="$t('Enter a sender email')" data-prepend="<span class='mif-mail'></span>" />
                
            </div>


            <div class="form-group">
                <div class="row">
                    <div class="cell-6">
                        <label>{{ $t("Username") }}*</label>
                        <input data-role="input" class="metro-input" type="text" v-model.trim="serviceAccount.username"
                            :placeholder="$t('Enter Username')" data-prepend="<span class='mif-person'></span>" />
                        
                    </div>
                    <div class="cell-6">
                        <label>{{ $t("Password") }}*</label>
                        <input v-if="[null, ''].includes(serviceAccount.id)" class="metro-input" data-role="input" type="password" v-model.trim="serviceAccount.password" :placeholder="$t('Enter Password')" v-no-autocomplete="'mif-lock'" />
                        <input v-else class="metro-input" data-role="input" type="password" data-reveal-button="false" data-prepend="<span class='mif-lock'></span>" value="**********" disabled/>
                    </div>
                </div>
            </div>

            <div class="form-group">
                <label>{{ $t("Recipient") }}*</label>
                <input data-role="input" type="text" v-model.trim="serviceAccount.options.recipient"
                    :placeholder="$t('Enter recipient email')" data-prepend="<span class='mif-mail'></span>" />
                
            </div>

            <!--<div class="form-group">
                <div class="row">
                    <div class="cell-8">
                        <label>Server SMTP</label>
                        <input data-role="input" class="metro-input" type="text" v-model="serviceAccount.url"
                            :placeholder="$t('Enter Domain')" data-prepend="<span class='mif-cloud'></span>" disabled/>
                        <small class="text-muted">{{ $t("Required") }}</small>
                    </div>
                    <div class="cell-4 ">
                        <label class="text-upper">{{ $t("Port") }}</label>
                        <input data-role="input" class="metro-input" type="text" v-model="serviceAccount.port"
                            :placeholder="$t('Enter Domain')" data-prepend="<span class='mif-cloud'></span>" disabled/>
                        <small class="text-muted">{{ $t("Required") }}</small>
                    </div>
                </div>
            </div>-->

            <div class="form-group">
                <div class="row">
                    <div class="cell-12 ">
                        <input data-role="checkbox" type="checkbox"
                            :data-caption="$t('Use secure connection (SSL/TLS)')" v-model="serviceAccount.use_ssl"
                            required data-prepend="<span class='mif-lock'></span>" disabled />
                    </div>
                </div>
            </div>

            <div class="form-group">
                <div class="row">
                    <div class="cell-12 ">
                        <input data-role="checkbox" type="checkbox" :data-caption="$t('Use POP3')"
                            v-model="serviceAccount.options.usePop3" required
                            data-prepend="<span class='mif-lock'></span>" />
                    </div>
                </div>
            </div>

            <div class="form-group">
                <div class="row">
                    <div class="cell-6">
                        <label>{{ $t("POP Username") }}*</label>
                        <input data-role="input" class="metro-input" type="text"
                            v-model.trim="serviceAccount.options.popUsername" :placeholder="$t('Enter Username')"
                            data-prepend="<span class='mif-person'></span>" />
                        
                    </div>
                    <div class="cell-6">
                        <label>{{ $t("Password") }}*</label>
                        <input v-if="[null, ''].includes(serviceAccount.id)" class="metro-input" data-role="input" type="password" v-model.trim="serviceAccount.options.popPassword" :placeholder="$t('Enter Password')" v-no-autocomplete="'mif-lock'" />
                        <input v-else class="metro-input" data-role="input" type="password" data-reveal-button="false" data-prepend="<span class='mif-lock'></span>" value="**********" disabled/>
                    </div>
                    
                </div>
            </div>

            <div class="form-group" v-if="serviceAccount.type == '7'">
                <div class="row">
                    <div class="cell-8">
                        <label>POP Server*</label>
                        <input data-role="input" class="metro-input" type="text"
                            v-model.trim="serviceAccount.options.popServer" :placeholder="$t('Enter POP Server')"
                            data-prepend="<span class='mif-cloud'></span>" />
                        
                    </div>
                    <div class="cell-4 ">
                        <label class="text-upper">{{ $t("POP Port") }}*</label>
                        <input data-role="input" class="metro-input" type="text"
                            v-model.trim="serviceAccount.options.popPort" :placeholder="$t('Enter POP Port')"
                            data-prepend="<span class='mif-cloud'></span>" />
                        
                    </div>
                </div>
            </div>
            <!-------------------------------SCELTA PC----------------------------------------->
            <div v-if="$session.getRoomPC() == null" class="form-group">
                <SelectPCByGroup @selectPC="(pc) => {testPC = pc}" 
                    :groupLabel="$t('Select the group to which the endpoint should belong to test the {0} connection', {0: $ONEServiceTypeInfo[serviceAccount.type].name})" 
                    :pcLabel="$t('Select an endpoint from which test the {0} connection', {0: $ONEServiceTypeInfo[serviceAccount.type].name})" 
                    :showSATestMsg="true" :selectIfOnline="true"
                />
            </div>
        </div>
        <!-------------------------------TEST ACCOUNT----------------------------------------->
        <div class="dialog-actions d-flex">
            <div v-if="tested == TEST_WAIT"><span class="mif-spinner2 ani-spin" /></div>
            <button class="button bg-amber" @click="test" :disabled="!enableTest" v-disable-tooltip="$t('Edit connection credentials before testing the account.')">{{ $t("Test Account") }}</button>
            <button class="button secondary" :disabled="!enableSave" v-disable-tooltip="$t('You can save the account only if the account test is successful.')" @click="saveServiceAccount(serviceAccount)">{{ $t("Save") }}</button>
        </div>
    </div>
</template>

<script>
import DialogTitle from "../../utils/DialogTitle.vue";
import { draggableMixin } from '../../../mixins/draggable-mixin'
import SelectPCByGroup from "../../utils/SelectPCByGroup.vue";
import { saveServiceAccount, testServiceAccount } from "../../../utils/entityMethods/serviceAccount";

export default {
    mixins: [draggableMixin],
    name: "EmailServiceAccount",
    components: {
        "DialogTitle": DialogTitle,
        SelectPCByGroup
    },
    props: {
        serviceAccount: Object,
    },
    data() {
        return {
            testPC: null,

            // -1 : avviato
            // 0 : non avviato o fallito
            // 1 : ok
            tested: 0,
            TEST_NOTOK: 0,
            TEST_WAIT: -1,
            TEST_OK: 1,
        }
    },
    computed: {
        allInputCompleted() {
            return this.serviceAccount.name != "" && (this.$session.getRoomPC() != null || this.testPC != null) &&
                this.serviceAccount.url != "" &&
                this.serviceAccount.username != "" &&
                this.serviceAccount.password != "" &&
                this.serviceAccount.options.senderAddress != "";
        },
        enableTest() {
            return this.allInputCompleted && this.tested == this.TEST_NOTOK;
        },
        enableSave() {
            return this.allInputCompleted && (this.tested == this.TEST_OK || this.tested == this.TEST_NOTOK && this.serviceAccount.id != null);
        }

    },
    created() {
        if (this.serviceAccount.options.lastTestPC != null)
            this.testPC = this.$session.getPCWithID(this.serviceAccount.options.lastTestPC);
    },
    methods: {
        saveServiceAccount,
        testServiceAccount,

        async test() {
            this.tested = (await this.testServiceAccount(this.serviceAccount, this.testPC)).okNumber;
        }
    }

}

</script>
